const urlDev = 'https://dev-api.sdconsulta.com.br/solicitacao-open/v1'
const urlProd = 'https://api.sdconsulta.com.br/solicitacao-open/v1'

const isDevHosts = [
  'localhost',
  'homologacao.senhadigitalplus.com.br',
  'leonardo.senhadigitalplus.com.br',
  'link.senhadigitalplus.com.br',
]

const currentHost = window.location.hostname

const isDev = isDevHosts.includes(currentHost)

const url = isDev ? urlDev : urlProd

const idDev = 'd73572f0-41fe-46c6-99cf-e4e222db4f94'
const idProd = '8d76f814-aaff-413a-bac6-24d35bd94b44'
const id = isDev ? idDev : idProd

const headers = {
  'x-api-key': `${id}`,
}
export const state = () => ({
  sdc: null,
})

export const getters = {}

export const mutations = {}

export const actions = {
  async searchExistingCompany({ commit }, cpfCnpj) {
    const data = await this.$axios.$get(`${url}/${cpfCnpj}`, {
      headers,
    })
    return data
  },
  async createSolicitacaoCompany({ commit }, payload) {
    await this.$axios.$post(url, payload, { headers })
  },
}